/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTypesResponseDto } from './ComponentTypesResponseDto';
import {
    ComponentTypesResponseDtoFromJSON,
    ComponentTypesResponseDtoFromJSONTyped,
    ComponentTypesResponseDtoToJSON,
    ComponentTypesResponseDtoToJSONTyped,
} from './ComponentTypesResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListComponentTypesResponseDto
 */
export interface ListComponentTypesResponseDto {
    /**
     * 
     * @type {Array<ComponentTypesResponseDto>}
     * @memberof ListComponentTypesResponseDto
     */
    data: Array<ComponentTypesResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListComponentTypesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListComponentTypesResponseDto interface.
 */
export function instanceOfListComponentTypesResponseDto(value: object): value is ListComponentTypesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListComponentTypesResponseDtoFromJSON(json: any): ListComponentTypesResponseDto {
    return ListComponentTypesResponseDtoFromJSONTyped(json, false);
}

export function ListComponentTypesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListComponentTypesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ComponentTypesResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListComponentTypesResponseDtoToJSON(json: any): ListComponentTypesResponseDto {
    return ListComponentTypesResponseDtoToJSONTyped(json, false);
}

export function ListComponentTypesResponseDtoToJSONTyped(value?: ListComponentTypesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ComponentTypesResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

